import React from 'react';
import LicenseSettings from './license-settings.jsx';
import LibraryUpdate from './library-update.jsx';
import AdvancedSettings from './advanced-settings.jsx';
import { connect } from 'react-redux';
const { Fragment } = wp.element;
const { __ } = wp.i18n;
const { PanelBody } = wp.components;

class Settings extends React.Component {
	render() {
		return (
			<Fragment>
				<PanelBody
					title={ __( 'Premium Users' ) }
					initialOpen={ ! this.props.userStatus }
					className={ 'dsgn-settings__license' }
				>
					<Fragment>
						<LicenseSettings
							setUserStatusByLicense={ this.props.setUserStatusByLicense }
							userStatus={ this.props.userStatus }
						/>
					</Fragment>
				</PanelBody>
				<LibraryUpdate
					getLibrary={ this.props.getLibrary }
					importDesigns={ this.props.importDesigns }
				/>
				<AdvancedSettings />
			</Fragment>
		);
	}
}

// export default Designs

export default connect(
	// mapStateToProps:
	state => ( {
		userStatus: state.user.status,
		// designsCount: state.designs.designsCount,
		// importedSets: state.designs.importedSets,
	} ),
	//mapDispatchToProps:
	( dispatch ) => ( {
	/* 	updateDesignsCount: count => {
			dispatch( setDesignsCount( count ) );
		},
		updateDesignLibrary: designs => {
			dispatch( setDesignLibrary( designs ) );
		}, */
	} ),
)( Settings );



// WEBPACK FOOTER //
// ./src/settings.jsx